// ── DOT 정산서 훅 — 통합 훅의 thin wrapper ──────────────────────────────────
// 실제 로직은 settlement/useSettlement.js 의 SETTLEMENT_CONFIG['DOT'] 로 처리됨.
// 새 회사가 추가되어도 useSettlement.js 의 SETTLEMENT_CONFIG 만 수정하면 됨.
import { useSettlement } from '../settlement/useSettlement';

export function useSettlementDot() {
  return useSettlement('DOT');
}
